export default __webpack_public_path__ + "static/media/img_5.7a45c6fd.jpg";